import { Injectable } from '@angular/core';
import * as StompJs from '@stomp/stompjs';
import { ActivationState } from '@stomp/stompjs';
import { Subject } from 'rxjs';
import SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import { SocketClientState } from '../enums/socketClientState.enum';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private stompClient: StompJs.Client;
  private connectState = new Subject<SocketClientState>();
  private isDebuggingTime = false; // Set to true when debugging.
  private lastError: any = null;

  get state(): string {
    return this.stompClient?.state === 0 ? 'ACTIVE' : this.stompClient?.state === 1 ? 'DEACTIVATING' : 'INACTIVE';
  }

  get active(): boolean {
    return this.stompClient?.active;
  }

  get connected(): boolean {
    return this.stompClient?.connected;
  }

  get clientStomp(): Stomp.client {
    return this.stompClient;
  }

  get connectionState(): Subject<SocketClientState> {
    return this.connectState;
  }

  get lastErrorStatus(): number | null {
    return this.lastError?.status || null;
  }

  #debugMe(eventName: string = 'debug'): void {
    this.isDebuggingTime &&
      console.warn(`[${eventName}] state: ${this.state}, active: ${this.active}, connected: ${this.connected}`);
  }

  establishWebSocketConnection(path: string) {
    this.connectState.next(SocketClientState.INACTIVE);

    this.stompClient = new StompJs.Client({
      reconnectDelay: 5000,
      heartbeatOutgoing: 20000,
      heartbeatIncoming: 20000,
      onChangeState: (state: ActivationState) => {
        this.#debugMe('onChangeState');
        if (state === ActivationState.ACTIVE) {
          this.connectState.next(SocketClientState.ACTIVE);
        }
      },
      onConnect: () => {
        this.#debugMe('onConnect');
        this.connectState.next(SocketClientState.CONNECTED);
      },
      onWebSocketError: (error) => {
        this.#debugMe('onWebSocketError');
        this.lastError = error;
        this.errorCallBack(error);
      },
      onStompError: (error) => {
        this.#debugMe('onStompError');
        this.lastError = error;
        this.errorCallBack(error);
      },
      onDisconnect: () => this.#debugMe('onDisconnect'),
      onWebSocketClose: () => this.#debugMe('onWebSocketClose'),
      debug: (message: string) => this.isDebuggingTime && console.log(message)
    });

    this.stompClient.webSocketFactory = () => {
      return new SockJS(path);
    };

    this.stompClient.activate();
  }

  closeWebSocketConnection() {
    this.stompClient.deactivate().then(() => {
      this.connectState.next(SocketClientState.DISCONNECTED);
      this.connectState.complete();
    });
  }

  errorCallBack(error) {
    if (
      error.headers &&
      (error.headers.message.includes('Forbidden') ||
        error.headers.message.includes('There is not exactly one repuser currently logged in for this repairer site'))
    ) {
      this.connectState.next(SocketClientState.ERROR);
      this.closeWebSocketConnection();
    }
  }

  send(topic: string, message: any) {
    this.stompClient?.publish({
      destination: topic,
      body: JSON.stringify(message),
      skipContentLengthHeader: true
    });
  }
}
